import React from "react";
import "./BBSButton.css"; // Wir erstellen diese Datei im nächsten Schritt

const BBSButton = ({ children, onClick, variant = "green", className = "" }) => {
  // Wir mappen die Prop 'variant' auf eine CSS-Klasse
  const variantClass = variant === "red" ? "btn-bbs-red" : "btn-bbs-green";

  return (
    <button
      onClick={onClick}
      className={`btn-bbs ${variantClass} ${className}`}
    >
      {children}
    </button>
  );
};

export default BBSButton;